/**
 * Branding configuration for the DevPulse monorepo
 *
 * This file contains the minimal configuration needed to customize
 * the monorepo for your organization. It is not exported from the package.
 *
 * Users should edit this file to point to their own repositories.
 *
 * 🔒 FORK PROTECTION: This file is protected by .gitattributes to use "ours"
 * merge strategy. When you sync from upstream, your changes will be preserved.
 * See FORK_SYNC.md for details on keeping your fork up to date.
 *
 * 📝 TEMPLATE: See branding.template.ts for the upstream reference configuration.
 * When new config options are added upstream, you can reference the template.
 */
/**
 * Application name displayed in the UI
 */
export const appName = "Camunda";
/**
 * List of GitHub repository URLs to analyze
 *
 * Supported formats:
 * - https://github.com/owner/repo
 * - https://github.com/owner/repo.git
 * - git@github.com:owner/repo.git
 * - owner/repo
 */
export const repos = [
    "https://github.com/camunda/app-integrations",
    "https://github.com/camunda/camunda-cloud-management-apps",
    "https://github.com/camunda/c4-identity",
    "https://github.com/camunda/web-modeler",
    "https://github.com/camunda/grafana-dashboards",
    "https://github.com/camunda/alerts",
    "https://github.com/camunda/connectors",
    "https://github.com/camunda/console-frontend-e2e",
    "https://github.com/camunda/play",
    "https://github.com/camunda/camunda-operator",
    "https://github.com/camunda/infra-k8s-webhook",
    "https://github.com/camunda/camunda-optimize",
    "https://github.com/camunda/camunda",
    "https://github.com/camunda/camunda-docs",
    "https://github.com/camunda/camunda-platform-helm",
    "https://github.com/camunda/c4-connectors",
    "https://github.com/bpmn-io/form-js",
    "https://github.com/bpmn-io/bpmn-js",
    "https://github.com/bpmn-io/bpmn-js-element-templates",
    "https://github.com/bpmn-io/bpmn-js-example-custom-shapes",
    "https://github.com/bpmn-io/diagram-js",
    "https://github.com/bpmn-io/bpmn-moddle",
    "https://github.com/bpmn-io/dmn-js",
    "https://github.com/camunda/sap-connectors",
];
/**
 * OIDC authentication configuration (optional)
 *
 * Leave these empty to disable OIDC authentication.
 * When configured, users will be required to authenticate via OIDC.
 */
export const oidc = {
    /** OIDC authority URL (issuer endpoint) */
    authority: "https://weblogin.cloud.dev.ultrawombat.com",
    /** OIDC client ID from your identity provider */
    clientId: "GQ9NdEMNyAEcsQrhrjCdB3NdrKDCTNZV",
    /** Redirect URI after successful authentication */
    redirectUri: "https://devpulse.camunda.directory/callback",
    /** Redirect URI after logout */
    postLogoutRedirectUri: "https://devpulse.camunda.directory",
    /** OAuth scopes to request (space-separated) */
    scope: "openid profile email",
};
/**
 * GitHub OAuth configuration (optional)
 *
 * Leave these empty to disable GitHub OAuth.
 * Alternative to OIDC for GitHub-based authentication.
 */
export const githubOAuth = {
    /** GitHub OAuth client ID */
    clientId: "",
    /** GitHub OAuth callback URI */
    redirectUri: "http://localhost:5173/auth/github/callback",
};
